/* eslint-disable no-unused-vars */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import RadioGroup from '../RadioGroup'
import RadioButton from '../Radio'
import NewDateIntervalInput from 'component/DateIntervalInput/NewDateIntevalInput'
import { isEmpty} from 'utils/validations'
import Form from 'component/utils/Form'
import Select from '../Select/Select'
import _ from 'lodash'
import CloseIconSVG from 'component/svgComponents/close'
import moment from 'moment'

const FIELDS = ['idSourceDepositList', 'idDestinationDepositList']

const SideFilterForm = ({
  depositList,
  fields,

  setValueToField,
  sideFilterVisible,
  submit,
  translate,
  btnDisabled,

  closeFilters,
  values,
  user
}) => {
  const [formData,setFormData] = useState({status: 2, dtStart: null, dtEnd: null})
  const [previousFormData,setPreviousFormData] = useState({status: 2, dtStart: null, dtEnd: null})
  const renderOptions = (idDepositList, field, id) => {

    const renderOption = (deposit) => {
      const { idDeposit } = deposit
      const currentValue = values[field]
      const checked = idDepositList.some((depositId) => depositId === idDeposit)
      return (
        <div className='stock-transfer-options' onClick={() =>

          setValueToField(
            fields[field].input.name,
            checked
              ? currentValue.filter((i) => i !== idDeposit)
              : [...currentValue, idDeposit]
          )
        }>
        <label

          className='stock-transfer-label'
          key={idDeposit}

          style={{ display: 'block', margin: '.5rem auto', fontWeight: checked ? 'bold' : 'normal' }}
        >
          {deposit.idDeposit === "" ? deposit.dsDeposit : `${deposit.idDeposit} - ${deposit.dsDeposit}`}
        </label>
        <input checked={checked} className='margin-right stock-transfer-checkbox' type={"checkbox"} />
        </div>

      )
    }

    return (
      <>
        <strong style={{ display: 'block', margin: '1rem auto' }}>
          {translate(`stockTransfer.missionBlock.${id}.old`)}
        </strong>
        {depositList.map(renderOption)}
      </>
    )
  }

  const handleDate = (dates) => {
    const newFormData = {...formData}
    const dtStart = moment(dates[0]).format("YYYY-MM-DD")
    const dtEnd = moment(dates[1]).format("YYYY-MM-DD")

    newFormData.dtStart = dtStart
    newFormData.dtEnd = dtEnd

    setFormData(newFormData)

  }
  
  const handleStatus = (status) => {
    const newFormData = {...formData}
    newFormData.status = status
    setFormData(newFormData)
  }
  const options = [
    { value: 0, label: 'Aprovação',},
    { value: 1, label: 'Verificação'},
    { value: 2, label: 'Todos' },
  ]

  const resetFilter = () => {
    setFormData({dtStart: null, dtEnd: null, status: 2 })
  }
  const submitValues = () => {
    setPreviousFormData(formData)
    
    submit(formData)
    closeFilters()
  }
  return (
    <>
    <div style={{display: sideFilterVisible ? 'shown' : 'none'}} className='bg-filter' />
      <div style={{display: sideFilterVisible ? '' : 'none'}} className='right-filter-container'>
        <CloseIconSVG className="right-filter-svg" onClick={() => closeFilters()} />
        <h3 className='margin-bottom-triple'>
          <strong>{translate('mobile.filter')}</strong>
        </h3>

          <>
           
            <div className='radio-group-title-container'> <span className='radio-group-title'>Tipo de permissão</span> </div>
    
            <RadioGroup

              className={
                 'margin-top-small margin-bottom-almost-double'
              }
            >
              {options.map((val, i) => (
                <RadioButton
                  key={i}
                  checked={formData.status === val.value}
                  defaultChecked={!!val.checked}
                  onClick={() => handleStatus(val.value) }
                  name={`radioGroup.${val.value}`}
                  label={val.label}
                />
              ))}
            </RadioGroup>
          </>
          
        
        <div style={{marginTop: '30px'}} className='flex flex-row gap-filters'>

          <button
            className={`btn btn-danger-outline  full-w`}s
            onClick={resetFilter}>
            {translate('suggestions.cleanFilters')}
          </button>


          <button
            className={`btn btn-primary  full-w`}
            disabled={_.isEqual(previousFormData, formData) }
            onClick={submitValues}
            >
              {translate('commonReport.filter')}
          </button>

        </div>
    </div>
  </>

  )
}

SideFilterForm.propTypes = {
  depositList: PropTypes.array.isRequired,
  fields: PropTypes.object.isRequired,
  handleSideFilterElementChange: PropTypes.func.isRequired,
  setValueToField: PropTypes.func.isRequired,
  sideFilterVisible: PropTypes.bool.isRequired,
  submit: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  btnDisabled: PropTypes.bool.isRequired,
  resetFilters: PropTypes.func.isRequired,
  closeFilters: PropTypes.func.isRequired,
  user:PropTypes.object
}

export default Form({ fields: FIELDS })(SideFilterForm)

export { SideFilterForm }
